/** Guided demo link — set REACT_APP_DEMO_SCHEDULE_URL (Calendly, Typeform, etc.) in production. */
export function getDemoScheduleHref(): string {
  const configured = process.env['REACT_APP_DEMO_SCHEDULE_URL']?.trim();
  if (configured) {
    return configured;
  }
  return 'mailto:contact@strat-edu.com?subject=Schedule%20a%20guided%20demo%20of%20Strat-Edu';
}

export function isDemoScheduleConfigured(): boolean {
  return Boolean(process.env['REACT_APP_DEMO_SCHEDULE_URL']?.trim());
}

export const HOME_PAGE_TITLE =
  'Strat-Edu — Education Administration Platform';

export const HOME_META_DESCRIPTION =
  'Strat-Edu helps education leaders and administrative teams run evaluations, communications, consent workflows, budgets, inventory, and organization management from one workspace.';

export const PLATFORM_SUITE_ANCHOR = 'platform-suite';
